module.exports = __webpack_public_path__ + "img/oct-yellow.d7ea288f.svg";